import type { PlaceCategory, PlaceWithDistance } from '@shared/types';

export type InterestId =
  | 'beach'
  | 'food'
  | 'grocery'
  | 'walks'
  | 'fun'
  | 'medical'
  | 'shop'
  | 'travel'
  | 'stay';

export const INTEREST_CATALOG: { id: InterestId; label: string; placeCategory: PlaceCategory }[] = [
  { id: 'beach', label: 'Beaches', placeCategory: 'beach' },
  { id: 'food', label: 'Food', placeCategory: 'food' },
  { id: 'grocery', label: 'Grocery', placeCategory: 'grocery' },
  { id: 'walks', label: 'Walks', placeCategory: 'attraction' },
  { id: 'fun', label: 'Fun', placeCategory: 'recreation' },
  { id: 'medical', label: 'Medical', placeCategory: 'medical' },
  { id: 'shop', label: 'Shop', placeCategory: 'shopping' },
  { id: 'travel', label: 'Day trips', placeCategory: 'travel' },
  { id: 'stay', label: 'Stay', placeCategory: 'resort' },
];

export type PlaceFilterCategory = PlaceCategory | 'all';

export const PLACE_FILTER_CATEGORIES: { key: PlaceFilterCategory; label: string }[] = [
  { key: 'all', label: 'All' },
  ...INTEREST_CATALOG.map((i) => ({ key: i.placeCategory, label: i.label })),
];

export function parsePlaceFilterCategory(value: string | null | undefined): PlaceFilterCategory {
  if (!value || value === 'all') return 'all';
  return PLACE_FILTER_CATEGORIES.some((c) => c.key === value) ? (value as PlaceFilterCategory) : 'all';
}

export const CATEGORY_SHORT: Record<PlaceCategory, string> = {
  beach: 'Beach',
  food: 'Food',
  grocery: 'Grocery',
  medical: 'Medical',
  shopping: 'Shop',
  recreation: 'Fun',
  attraction: 'Walk',
  travel: 'Travel',
  resort: 'Resort',
};

export function placesForInterest(
  places: PlaceWithDistance[],
  interest: (typeof INTEREST_CATALOG)[number],
): PlaceWithDistance[] {
  return places.filter((p) => p.category === interest.placeCategory);
}
